export default [
  {
    path: "/",
    component: () => import("@/views/pymt/layouts/PaymentWrapper.vue"),
    children: [
      {
        name: "Payment",
        path: "pymt/:id",
        component: () => import("@/views/pymt/Index.vue"),
      },
      {
        name: "Payment Sucess",
        path: "pymt/success/:id",
        component: () => import("@/views/pymt/Success.vue"),
      },
      {
        name: "Payment Sucess",
        path: "pymt/fail/:id",
        component: () => import("@/views/pymt/Failure.vue"),
      },
    ],
  },
];
